import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ngc-ghost-table',
    templateUrl: './ghost-table.component.html',
    styleUrls: ['./ghost-table.component.scss']
})

export class GhostTableComponent implements OnInit {

    @Input() set rowsNumber(value: number) {
        this.rows = new Array<any>(value);
    }
    @Input() rows: Array<any>;
    @Input() isList: boolean;

    constructor() { }

    ngOnInit() {
    }

}
